<template lang="pug">
.v-field-currency.field-currency(:class="['field-currency--' + view, {'field-currency--open': open, 'field-currency--sm': field.size === 'sm'}]")
	label.field-currency__label(v-if="field.label" :for="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	button.field-currency__btn(type="button" @click="open = !open" :id="uniqueId" :disabled="field.disabled" :class="{'open': open}")
		img.field-currency__btn-image(v-if="activeOption.image" :src="activeOption.image" alt="" loading="lazy")
		span.field-currency__btn-placeholder(v-if="!activeOption && field.placeholder" key="placeholder") {{field.placeholder}}
		span.field-currency__btn-text(v-else-if="activeOption" key="text") {{activeOption.text}}
		v-svg-icon.field-currency__btn-arrow(icon="down")
	.field-currency__list(:class="{'open': open}" @click="open = false;")
		.field-currency__list-container
			template(v-for="(option, index) in field.options" :key="index")
				button.field-currency__list-item(type="button"
					@click="handleInput(option)"
					:class="{'active': option.value === activeOption.value}")
					img.field-currency__btn-image(v-if="option.image" :src="option.image" alt="" loading="lazy")
					span.field-currency__list-item-text {{option.text}}
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [Object, String, Number, Boolean, Symbol, Date],
			default: null
		},

		view: {
			type: String,
			default: 'regular'
		}
	},

	emits: [
		'update:model-value',
		'disabled-option-select'
	],

	data() {
		return {
			localValue: null,
			open: false,
			uniqueId: uniqueId('field-currency_'),
			hasFocus: false,
			selectValueText: '',
			isSelectValueFound: false,
		};
	},

	computed: {
		activeOption() {
			if (this.field && this.field.options && this.field.options.length) {
				return this.field.options.find(option => option.value === this.localValue);
			}
			return null;
		}
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
		if (this.field.searchable && this.localValue) {
			this.selectValueText = this.activeOption ? this.activeOption.text || this.activeOption.value : '';
		}
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEsc);
	},

	unmounted() {
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('keydown', this.handleEsc);
	},

	methods: {
		handleClickSearchable(e, option) {
			this.localValue = option.value;
			this.handleInput();
			this.open = false;
			this.selectValueText = option.text;
		},

		cleanField() {
			if (this.foundSelectValue() !== this.selectValueText) {
				this.selectValueText = '';
				this.localValue = '';
			}
		},

		toggleOpen() {
			if (this.field.disabled) {
				return false;
			}
			this.open = !this.open;
			this.selectValueText = '';
		},

		foundSelectValue() {
			let result = false;
			if (this.field && this.field.options && this.field.options.length) {
				for (let i = 0; i < this.field.options.length; i++) {
					if (this.isFoundSelectText(this.field.options[i].text)) {
						result = this.field.options[i].text;
						this.isSelectValueFound = true;
						break;
					}
				}
				if (result) {
					this.isSelectValueFound = true;
				} else {
					this.isSelectValueFound = false;
				}
			}
			return result;
		},

		isFoundSelectText(text = '') {
			let vm = this;
			let result = false;
			let selectValueText = vm.selectValueText;
			if (!selectValueText) {
				selectValueText = '';
			}
			if (text.toLowerCase().indexOf(selectValueText.toLowerCase()) !== -1) {
				result = true;
			} else {
				result = false;
			}
			return result;
		},

		inputFocus() {
			this.hasFocus = true;
		},

		inputBlur() {
			this.hasFocus = false;
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput(option) {
			if (option.disabled) {
				this.$emit('disabled-option-select');
			} else {
				this.localValue = option.value;
				this.open = true;
				this.$emit('update:model-value', this.localValue);
			}
		},

		handleClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.open = false;
			}
		},

		handleEsc(e) {
			if (e.keyCode == 27 && this.open) {
				e.stopPropagation();
				this.open = false;
			}
		}
	}
};
</script>
